<template>
    <div>
        <!--Edit-->
        <div class="container">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Provisão de sinistros</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Relatórios Provisão Sinistros</a>
                        </li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-report-card">
                            <div class="card-body">
                                <div class="row gp-report-filters">
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Garantidora</label>
                                            <v-autocomplete v-model="GarantidoraSelected" :items="Garantidoras" item-title="garNomeEmpresa" item-value="garId"
                                                density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                no-data-text="Nenhum registro encontrado" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-2">
                                        <div class="form-group">
                                            <label for="percentual-provisao">Provisão (%)</label>
                                            <input id="percentual-provisao" v-model.trim="percentualProvisao" type="text"
                                                inputmode="decimal" class="form-control" placeholder="Ex.: 7,5" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <button type="button" class="btn btn-info"
                                            style="color:#ffffff;margin-top: 35px;" @click="Pesquisar()">
                                            Pesquisar
                                        </button>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <a href="#" @click="EditCancel()" class="btn btn-link"
                                            style="margin-top: 35px;">Cancelar</a>
                                    </div>
                                </div>
                                <div class="row" style="padding-top: 20px;padding-bottom: 20px;">
                                    <hr>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="d-flex align-items-center">
                                            <h4 class="card-title">Resultado<span v-if="provisaoAplicada !== null"> — provisão de {{ provisaoAplicada.toLocaleString('pt-BR', { maximumFractionDigits: 20 }) }}%</span></h4>
                                        </div>
                                        <v-row>
                                            <v-col cols="12" md="6" style="text-align: right;padding-right: 15px;">
                                                <button @click="exportCSV" class="btn btn-warning">Exportar CSV</button>
                                            </v-col>
                                        </v-row>
                                        <adm-data-table :headers="headers" :items="ListResult" v-model="itemsSelected" :show-filters="false" :show-export="true" file-name="provisao-sinistros"
                                            :export-formatters="{ percentualAplicado: valor => valor / 100 }"
                                            :export-number-formats="{ percentualAplicado: '0.##%', pedProvisao: '#,##0.00' }"
                                            alternating theme-color="#364f66" table-class-name="customize-table"
                                            header-text-direction="center" body-text-direction="center"
                                            rows-per-page-message="Linhas por pagina">
                                            <template #item-SumTotalPedido="item">
                                                <span> {{ item.SumTotalPedido !== null ?
                                                    formatarValor(item.SumTotalPedido) : null }}</span>
                                            </template>
                                            <template #item-percentualAplicado="item">
                                                {{ item.percentualAplicado.toLocaleString('pt-BR', { maximumFractionDigits: 20 }) }}%
                                            </template>
                                            <template #item-pedProvisao="item">
                                                <span> {{ item.pedProvisao !== null ?
                                                    formatarValor(item.pedProvisao) : null }}</span>
                                            </template>
                                        </adm-data-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios'
import EasyDataTable from 'vue3-easy-data-table'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document'
import moment from 'moment'

export default {
  name: 'RelatorioProvisaoSinistrosView',
  components: {
    EasyDataTable,
    moment
  },
  data: () => ({
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0
    },
    editor: DecoupledEditor,
    GarantidorasGeral: [],
    Garantidoras: [],
    GarantidoraSelected: null,
    percentualProvisao: '10',
    provisaoAplicada: null,
    ImobiliariasGeral: [],
    Imobiliarias: [],
    ImobiliariaSelected: null,
    ClientesGeral: [],
    Clientes: [],
    ClienteSelected: null,
    DataIncial: '',
    DataFinal: '',
    searchValue: '',
    itemsSelected: [],
    ListResult: [],
    ListPedidosGeral: [],
    ListPedidosGeralFiltro: [],
    ListaPedidoItem: [],
    headers: [
      { text: 'Garantidora', value: 'NomeGarantidora', sortable: true },
      { text: 'Qtde Contratos', value: 'pedQtde', sortable: true },
      { text: 'Valor Total', value: 'SumTotalPedido', sortable: true },
      { text: 'Provisão (%)', value: 'percentualAplicado', sortable: true },
      { text: 'Provisão (R$)', value: 'pedProvisao', sortable: true }
      // { text: 'Ações', value: 'actions' }
    ]
  }),
  methods: {
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    EditGrid (item) {

    },
    EditCancel () {
      this.$router.go(0)
    },
    GarantidoraEdit (Value) {
      this.Garantidoras = this.GarantidorasGeral.filter(x => x.garId == Value)
      this.GarantidoraSelected = Value
    },
    async Pesquisar () {
      const texto = String(this.percentualProvisao ?? '').trim()
      const percentual = Number(texto.replace(',', '.'))
      if (!/^\d+(?:[.,]\d+)?$/.test(texto) || !Number.isFinite(percentual) || percentual > 100) {
        this.$mensagemAviso('Informe o percentual de provisão entre 0 e 100. Ex.: 7,5.')
        return
      }
      // Validação: DataFinal não pode ser menor que DataIncial
      if (moment(this.DataFinal).isBefore(moment(this.DataIncial))) {
        this.$mensagemAviso('Data Final não pode ser menor que Data Inicial!')
        return
      }

      // Define os parâmetros para a consulta
      const _garId = this.GarantidoraSelected || 0
      const _tpeid = 0
      const _pesid = 0

      try {
        // Consulta os pedidos
        const response = await axios.get(
                    `/Telas/RelatorioProvisaoSinistros/GetAllValorTotal/${_garId}/${_tpeid}/${_pesid}`
        )
        // Filtra para pegar somente os pedidos com situação "Vigente"
        this.ListPedidosGeral = response.data.filter(
          (x) => x.pedSituacaoPedido === 'Vigente'
        )

        // Inicia o filtro com a lista completa
        const filtered = [...this.ListPedidosGeral]

        // Supondo que "filtered" seja seu array já filtrado
        const agrupados = filtered.reduce((acc, item) => {
          // Se ainda não existe um grupo para esse garId, inicializa
          if (!acc[item.garId]) {
            acc[item.garId] = {
              garId: item.garId,
              SumTotalPedido: Number(item.pedValorTotalPedido) || 0,
              pedQtde: 1
            }
          } else {
            acc[item.garId].SumTotalPedido += Number(item.pedValorTotalPedido) || 0
            acc[item.garId].pedQtde += 1
          }
          return acc
        }, {})

        // console.log('agrupados')
        // console.log(agrupados)
        // Aplica o percentual da pesquisa sobre o total vigente de cada garantidora.
        const resultadoAgrupado = Object.values(agrupados).map(grupo => {
          const garantidora = this.GarantidorasGeral.find((g) => g.garId === grupo.garId)
          return {
            ...grupo,
            NomeGarantidora: garantidora ? garantidora.garNomeEmpresa : 'Não encontrada',
            percentualAplicado: percentual,
            pedProvisao: Number((grupo.SumTotalPedido * percentual / 100).toFixed(2))
          }
        })

        // console.log('resultadoAgrupado')
        // console.log(resultadoAgrupado);

        // Ordenação final: ordena por NomeGarantidora
        this.ListResult = resultadoAgrupado.sort((a, b) => {
          return (
            a.NomeGarantidora.localeCompare(b.NomeGarantidora)
          )
        })
        this.provisaoAplicada = percentual
      } catch (error) {
        console.error(error)
      }
    },
    exportCSV () {
      if (this.ListResult.length === 0) {
        alert('Não há dados para exportar.')
        return
      }

      // Criar cabeçalho CSV
      const csvHeader = this.headers.map(h => h.text).join(';') + '\n'

      // Criar linhas do CSV
      const csvRows = this.ListResult.map(item =>
        [
          item.NomeGarantidora,
          item.pedQtde,
          item.SumTotalPedido,
          item.percentualAplicado.toLocaleString('pt-BR', { maximumFractionDigits: 20 }) + '%',
          item.pedProvisao
        ].join(';')
      ).join('\n')

      // Criar conteúdo CSV final
      const csvContent = 'data:text/csv;charset=utf-8,\uFEFF' + csvHeader + csvRows

      // Criar link de download
      const encodedUri = encodeURI(csvContent)
      const link = document.createElement('a')
      link.setAttribute('href', encodedUri)
      link.setAttribute('download', 'RelatorioProvisaoSinistros.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async Get () {
      await axios.get('/Telas/RelatorioProvisaoSinistros/GetDados')
        .then(response => {
          this.GarantidorasGeral = response.data.garGarantidoras.filter(x => x.garVisivel).sort((a, b) =>
            a.garNomeEmpresa.localeCompare(
              b.garNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )
          this.User.tpeid = response.data.tpeId
          this.User.garid = response.data.garId
          this.User.pesid = response.data.pesId

          this.ImobiliariasGeral = response.data.imobiliarias.sort((a, b) =>
            a.imoNomeEmpresa.localeCompare(
              b.imoNomeEmpresa,
              'pt',
              { sensitivity: 'base' }
            )
          )

          if (this.User.garid == 0) {
            this.EditView = false
            this.Garantidoras = this.GarantidorasGeral
          } else {
            this.GarantidoraEdit(this.User.garid)
          }
          // this.montaGrid();
        })
    }
  },
  created () {
    this.Get()
  }
}
</script>

<style></style>
